export type Language = 'zh-TW' | 'en' | 'ja';

export const LANGUAGE_LABELS: Record<Language, string> = {
  'zh-TW': '繁體中文（台灣）',
  en: 'English',
  ja: '日本語',
};

